/* unplugin-vue-components disabled */import { render } from "./SeatingPlan.vue?vue&type=template&id=6fa2d5d4&ts=true"
import script from "./SeatingPlan.vue?vue&type=script&lang=ts"
export * from "./SeatingPlan.vue?vue&type=script&lang=ts"

import "./SeatingPlan.vue?vue&type=style&index=0&id=6fa2d5d4&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__